import { render } from "./coachList.vue?vue&type=template&id=eb67b618&scoped=true"
import script from "./coachList.vue?vue&type=script&lang=js"
export * from "./coachList.vue?vue&type=script&lang=js"

import "./coachList.vue?vue&type=style&index=0&id=eb67b618&scoped=true&lang=scss"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb67b618"]])

export default __exports__